var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _polygon, _path13, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8192 798.5",
    style: {
      enableBackground: "new 0 0 8192 798.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#1A2042;}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{fill:url(#SVGID_7_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -481.0847,
    y1: 219.2223,
    x2: -1776.1656,
    y2: 519.8291,
    gradientTransform: "matrix(0.802 0 0 0.802 1504.1444 32.009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A99FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C64F2"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M578,158.6c-29-52.7-56.2-66.7-101.1-66.7h-51.7c-37,0-63.2,14-92.2,66.7l-33.3,61.1l56.8,22.4 c18.5,7.2,27.7,28.2,20.4,46.8c-3.6,9.3-11.1,16.8-20.4,20.4L297,332.7c-3.2,1.3-5.7,3.8-7,7l-23.9,60.1 c-4.6,11.5-14.7,19.9-26.9,22.2c-2.2,0.4-4.4,0.7-6.6,0.7c-9.4,0-18.5-3.8-25.1-10.5c-3.2-2.8-5.8-6.4-7.4-10.3L45,686.2 c-6.1,11.5-3.5,20.4,11.5,20.4h114.2c10.5,0,15.7-2.8,20.1-11.5l20.4-38.3h0.2l26.7-50l13.4-24.7L357,386.3l87.5-163.6 c0-0.2,0.2-0.4,0.7-1c0.4-0.7,0.9-1.2,1.2-1.6c7-10.1,35.1-44.9,82.9-44.7c52.2,0,80.5,41.7,85,48.6L578,158.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1542.6,91.9c13.1,0,19.3,6.1,19.3,19.4v86c0,13.1-6.1,20.3-19.3,20.3h-390.7c-90.4,0-116.7,26.3-116.7,119.5 v124.6c0,93.1,26.4,120.3,116.7,120.3h390.7c13.1,0,19.3,6.1,19.3,19.3v86.1c0,13.1-6.1,19.4-19.3,19.4h-395.9 c-177.4,0-245.8-63.2-245.8-231.8V323.7c0-168.6,68.4-231.8,245.8-231.8H1542.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2290.6,91.9c13.1,0,19.3,6.1,19.3,19.4v86c0,13.1-6.1,20.3-19.3,20.3h-390.7c-90.4,0-116.7,26.3-116.7,119.5 v124.6c0,93.1,26.4,120.3,116.7,120.3h390.7c13.1,0,19.3,6.1,19.3,19.3v86.1c0,13.1-6.1,19.4-19.3,19.4h-395.9 c-177.4,0-245.8-63.2-245.8-231.8V323.7c0-168.6,68.4-231.8,245.8-231.8H2290.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2913.7,91.9c178.3,0,245.8,63.2,245.8,231.8v151c0,168.6-67.6,231.8-245.8,231.8h-271.3 c-177.4,0-245.8-63.2-245.8-231.8v-151c0-168.6,68.4-231.8,245.8-231.8H2913.7z M2530.9,465c0,92.2,26.4,119.5,116.7,119.5h260.8 c90.4,0,116.7-27.3,116.7-119.5V333.3c0-92.2-26.3-119.5-116.7-119.5h-260.8c-90.4,0-116.7,27.3-116.7,119.5V465z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3381.5,91.9c13.1,0,19.3,6.1,19.3,19.4v350.3c0,93.1,26.4,120.3,116.7,120.3h243.2 c90.4,0,115.8-27.3,115.8-120.3V111.2c0-13.1,6.1-19.4,19.3-19.4h95.7c13.1,0,19.3,6.1,19.3,19.4v363.5 c0,168.6-67.6,231.8-245.8,231.8h-252.8c-177.4,0-245.8-63.2-245.8-231.8V111.2c0-13.1,7-19.4,20.1-19.4h95V91.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4282.1,91.9c56.2,0,68.4,7,101.8,51.8l326.6,428.4c2.6,4.4,6.1,6.1,11.4,6.1h7.9c4.4,0,7-2.6,7-8.9V111.2 c0-13.1,6.1-19.4,19.3-19.4h92.2c13.1,0,19.4,6.1,19.4,19.4v504c0,71.1-25.5,91.3-79.1,91.3h-75.5c-53.5,0-66.7-5.3-101.8-51.8 l-327.5-428.4c-3.5-4.4-6.1-6.1-11.4-6.1h-7.9c-5.3,0-7,2.6-7,8.8v458.3c0,13.1-6.1,19.4-19.3,19.4H4146 c-13.1,0-20.1-6.1-20.1-19.4v-504c0-71.1,25.4-91.3,79.1-91.3C4204.9,91.9,4282.1,91.9,4282.1,91.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5652.4,91.9c13.1,0,20.1,6.1,20.1,19.4v86c0,13.1-7,20.3-20.1,20.3h-275.7v469.6c0,13.1-6.1,19.4-19.3,19.4 h-95.7c-13.1,0-19.3-6.1-19.3-19.4V217.5h-275.7c-13.1,0-20.1-7-20.1-20.3v-86.1c0-13.1,7-19.4,20.1-19.4h685.6V91.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 5259.1748,
    y1: -186.2461,
    x2: 5473.5645,
    y2: 969.5998,
    gradientTransform: "matrix(0.802 0 0 0.802 1504.1444 32.009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A99FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C64F2"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5865.6,91.9c13.1,0,19.4,6.1,19.4,19.4v575.9c0,13.1-6.1,19.4-19.4,19.4h-94.8c-13.1,0-20.1-6.1-20.1-19.4 V111.3c0-13.1,7-19.4,20.1-19.4H5865.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6579.4,91.9c47.4,0,69.4,21.1,69.4,66.8v79.9c0,43-9.6,55.3-43.9,73.7l-464.5,244.9c-6.1,3.5-7.9,7-7.9,13.1 v6.1c0,5.3,2.6,7.9,8.9,7.9h482c13.1,0,20.1,6.1,20.1,19.3v83.4c0,13.1-7,19.4-20.1,19.4h-568.2c-48.3,0-69.3-21-69.3-65.8v-79.9 c0-43,7-55.3,41.3-73.7l462.7-245.8c6.1-3.5,7.9-7,7.9-13.1V222c0-5.3-3.5-7.9-8.8-7.9h-477.6c-13.1,0-20.1-6.1-20.1-19.3v-83.4 c0-13.1,7-19.4,20.1-19.4h567.9V91.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7359.7,91.9c13.1,0,20.3,6.1,20.3,19.4v83.4c0,13.1-7,19.3-20.3,19.3h-383.7c-91.3,0-116.8,27.3-116.8,119.5 v8.9h496.1c13.1,0,19.3,6.1,19.3,19.3v69.3c0,13.1-6.1,19.4-19.3,19.4h-496.1v14.9c0,92.2,25.5,119.5,116.8,119.5h383.7 c13.1,0,20.3,6.1,20.3,19.3v83.3c0,13.1-7,19.4-20.3,19.4h-386.3c-177.4,0-245.8-63.2-245.8-231.8V323.7 c0-168.6,68.5-231.8,245.8-231.8H7359.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7978.6,91.9c134.3,0,188.8,62.3,188.8,180.9v50c0,100.1-38.7,158.9-130.8,175.6l150.1,186.1 c5.3,6.1,4.4,22-11.4,22H8062c-14.9,0-19.3-3.5-24.6-11.4l-138.7-182.6h-283.6v174.7c0,13.1-6.1,19.4-19.3,19.4H7501 c-13.1,0-20.1-6.1-20.1-19.4V118.2c0-17.5,8.8-26.4,26.3-26.4h471.5V91.9z M7615.1,405.3h336.3c59.7,0,81.7-25.4,81.7-78.2v-36.8 c0-52.7-22-78.2-81.7-78.2h-324.9c-7.9,0-11.4,3.5-11.4,10.5V405.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -1841.7606,
    y1: 119.1122,
    x2: -1541.4937,
    y2: 471.6775,
    gradientTransform: "matrix(0.802 0 0 0.802 1504.1444 32.009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#58F3C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#465DF4"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.3,194.7l-21.7-8.5c-2.3-0.9-3.5-3.6-2.5-5.9c0.4-1.2,1.4-2.1,2.5-2.5l21.7-8.5c3.3-1.3,6-3.9,7.3-7.3 l8.5-21.7c0.9-2.3,3.6-3.5,5.9-2.5c1.2,0.4,2.1,1.4,2.5,2.5l8.5,21.7c1.3,3.3,3.9,6,7.3,7.3l21.7,8.5c2.3,0.9,3.5,3.6,2.5,5.9 c-0.4,1.2-1.4,2.1-2.5,2.5l-21.8,8.4c-3.3,1.3-6,3.9-7.3,7.3l-8.5,21.7c-0.9,2.3-3.6,3.5-5.9,2.5c-1.2-0.4-2.1-1.4-2.5-2.5 l-8.5-21.7C59.2,198.6,56.6,196,53.3,194.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -1934.0038,
    y1: 197.6652,
    x2: -1633.7266,
    y2: 550.2305,
    gradientTransform: "matrix(0.802 0 0 0.802 1504.1444 32.009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#58F3C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#465DF4"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M12.6,275.3l-8.9-3.5c-1-0.3-1.4-1.4-1.1-2.4c0.2-0.4,0.5-0.9,1.1-1.1l8.9-3.5c1.4-0.5,2.4-1.6,3-3L19,253 c0.3-1,1.4-1.4,2.4-1.1c0.4,0.2,0.9,0.5,1.1,1.1l3.5,8.9c0.5,1.3,1.6,2.4,3,3l8.9,3.5c1,0.3,1.4,1.4,1.1,2.4 c-0.2,0.4-0.5,0.9-1.1,1.1l-8.9,3.5c-1.3,0.5-2.4,1.6-3,3l-3.5,8.9c-0.3,1-1.4,1.4-2.4,1.1c-0.4-0.2-0.9-0.5-1.1-1.1l-3.5-8.9 C15,276.9,13.9,275.8,12.6,275.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -1784.4471,
    y1: 70.2944,
    x2: -1484.1802,
    y2: 422.8596,
    gradientTransform: "matrix(0.802 0 0 0.802 1504.1444 32.009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#58F3C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#465DF4"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M348.2,287.3l-10.4,4.1L288.3,311c-9.3,3.7-16.6,11.1-20.3,20.3l-23.7,60c-2.5,6.5-9.9,9.5-16.3,7 c-1.6-0.7-3.2-1.6-4.5-3c-1.3-1.1-2.2-2.4-2.7-4.1l-23.7-60c-3.7-9.2-11.1-16.5-20.3-20.3l-60-23.7c-10.6-4.3-10.6-19.3,0-23.4 l60-23.7c9.3-3.7,16.6-11.1,20.3-20.3l23.7-59.8c2.5-6.5,9.7-9.7,16.2-7.2c3.4,1.3,6,3.9,7.2,7.2l23.7,59.8 c3.6,9.3,10.9,16.6,20.3,20.3l16.3,6.4l33.2,13.4l10.4,4.1c6.5,2.4,9.7,9.7,7.3,16.2C354.2,283.4,351.5,286,348.2,287.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "238,606.6 211.3,656.8 211.1,656.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -903.8253,
    y1: 805.8952,
    x2: -1206.0311,
    y2: 247.5454,
    gradientTransform: "matrix(0.802 0 0 0.802 1504.1444 32.009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A99FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C64F2"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M858.1,706.6H746.5c-11.5,0-15.7-2.8-20.1-11.5l-21-38.3L537.3,348.3H537l-41-75.5l-27.2-50.1 c-2.6-4.5-5.1-6.1-9.6-6.1h-5.1c-3.5,0-5.8,1-8,3.5c7-10.1,35.1-44.9,82.9-44.7c52.2,0,80.5,41.7,85,48.6l0.4,1l254.1,461.3 C874.7,697.7,872.1,706.6,858.1,706.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -437.0748,
    y1: 408.8327,
    x2: -1732.1558,
    y2: 709.4395,
    gradientTransform: "matrix(0.802 0 0 0.802 1504.1444 32.009)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A99FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C64F2"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "607.6,476.9 197.3,476.9 197.3,578.8 662.8,578.8  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo_blue.e178a71682a9ea6991fae2e6b29b8352.svg";
export { ForwardRef as ReactComponent };